/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Register.css';
import P from 'react-particles-js'
import Link from '../../components/Link'
import history from '../../history'
import moment from 'moment'
import cx from 'classnames';
import FloatNews from '../../components/FloatNews'
import { getPhoneCode, checkPhone, register, login } from '../../controller';
import bgOption from './bgOption'

class Register extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired
  };
  constructor(props) {
    super(props)
    this.state = {
      urlBase: '/digitalAssets/',
      url:'',
      name:'',
      sex:'0',
      email:'',
      company:'',
      job:'',
      phone:'',
      password:'',
      passwordAgain:'',
      imgCode:'',
      phoneCode:'',
      isErr:false,
      isChecked:true,
      data:null,
      error:null,
      time:60,
      isGetPhone:false,
      getPhoneTxt:false,
      errTxt:'',
      m:'',
      formDataName:null,
      formDataSex:null,
      formDataEmail:null,
      formDataCom:null,
      formDataJob:null,
      formDataPhone:null,
      formDataPsw:null,
      formDataPswAg:null,
      getCodeBtn:false,
      modelOpen:false,

      seaCompleteItem:[],
      isFixed:false,
      listIndex:0,
      selectIndex:0,
      mouseLeave:true,
      floatNews:false
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.getPhoneCode = this.getPhoneCode.bind(this)
    this.saveToState=this.saveToState.bind(this)
    this.checkPic=this.checkPic.bind(this)
    this.valid=this.valid.bind(this)
    this.getBrand=this.getBrand.bind(this)

    this.seaComplete=this.seaComplete.bind(this)
    this.mouseSlect=this.mouseSlect.bind(this)
    this.mouseOnClick=this.mouseOnClick.bind(this)
    this.mouseLeave=this.mouseLeave.bind(this)
    this.mouseEnter=this.mouseEnter.bind(this)
    this.isFocusFalse=this.isFocusFalse.bind(this)
    this.keyDown=this.keyDown.bind(this)
  }
  getBrand=(brand)=>{
    console.log(brand)
    this.setState({company:brand})
  }


  seaComplete=(value)=>{
    if(value!=''){
      const url=`/digitalAssets/s?q=${value}`
      
        fetch(url).then(response => response.json())
        .then(data => {
          this.setState({
              seaCompleteItem: data.items
          })
        })
        .catch(e => console.log("Oops, error", e))
    }
  }
  mouseEnter=()=>{
    this.setState({mouseLeave:false})
  }
  mouseLeave=()=>{
    this.setState({mouseLeave:true})
  }

  mouseSlect=(index)=>{
    this.setState({selectIndex:index})
  }

  mouseOnClick=()=>{
    const {seaCompleteItem,selectIndex}=this.state
    // this.props.getBrand(seaCompleteItem[selectIndex].name)
    this.setState({
      company:seaCompleteItem[selectIndex].name,
      seaCompleteItem:[]
    })
  
  }
  
  isFocusFalse=()=> {
    // console.log('失去焦点')
    if(this.state.mouseLeave){
      this.setState({
        seaCompleteItem: []
      })
    }
  
  }
  keyDown=(e)=> {
        const { selectIndex, seaCompleteItem,value,company,isFixed } = this.state
        const {}=this.props
        const num =  seaCompleteItem.length-1
      
        // console.log(value,num,selectIndex,'aaaaaaaaaaaaaaaaaaaaaaaa',e.key,selectIndex<0)
       if(e.key=='Enter'&&isFixed){
          this.setState({
            company:seaCompleteItem[selectIndex].name,
            seaCompleteItem:[]
          })
          
       }else if(e.key=='ArrowUp'&&seaCompleteItem.length!=0){

            let cc=selectIndex<1?num:selectIndex-1
            this.setState({selectIndex:cc})
       }else if(e.key=='ArrowDown'&&seaCompleteItem.length!=0){

            // this.setState({selectIndex:selectIndex+1,value:items[num]['name']})
            let cc=selectIndex<1?selectIndex+1:selectIndex+1
            this.setState({selectIndex:cc})
      }else if(e.key=='Backspace'&&company.length==1){
          this.setState({seaCompleteItem:[]})

      }
  }



  tick=()=>{
    if(this.state.getPhoneTxt){
      this.setState((prevState)=>({
        time:prevState.time-1
      }))
    }
    if(this.state.time<=0){
      this.setState({getPhoneTxt:false})
    }
  }
  componentWillMount() {
    let m=moment().format('x')
    this.setState({
      m:m,
      url:`/digitalAssets/get_img_code?timestamp=${m}`
      
    })
  }
  componentDidMount() {
    this.interval=setInterval(()=>this.tick(),1000)
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  
  

  saveToState=(e)=>{
    const{name,value}=e.target

    this.setState({
      [name]:value,
      isErr:false,
    })
    if(name=='company'){
      this.seaComplete(e.target.value)
    }
   
  }
  checkPic=(e)=>{
    if(e.target.value.length==4){
      const code=e.target.value
      const url = `/digitalAssets/check_img_code?code=${code}&timestamp=${this.state.m}`;
      
      fetch(url).then(response => response.json())
      .then(data => {
        // console.log(data,'验证图片')
        if(data.img_code){

          this.setState({
              isGetPhone:true        
          })
        }
      
      })
      .catch(e => console.log("Oops, error", e))
    }
  }


  getPhoneCode() {
    const { phone, getPhoneTxt, getCodeBtn } = this.state
    if(phone.length == 11 && !getPhoneTxt && getCodeBtn){
      const query = new FormData()
      query.set('phone', phone)
      query.set('type', '1')
      // const url = `/digitalAssets/get_phone_code?phone=${this.state.phone}&type=0`;
      getPhoneCode(query)
        .then(res => {
          this.setState({
            data: res,
            time:60,
            getPhoneTxt:true,
          })
          if(res.err_msg=='phone_code is expired'){
            this.setState({errTxt:'验证码错误'})
          }else if(res.err_msg=='phone already exists'){
            this.setState({errTxt:'手机号已经注册'})
          }
        })
    }else if(this.state.getPhoneTxt){

    }else{
      this.setState({
        errTxt:'请输入正确手机',
        isErr:true
      })
    }
  }

  valid=(e)=>{
    // console.log(e.target.value,e.target.name)
    const {formDataName,formDataEmail,formDataCom,formDataJob,formDataPhone,formDataPsw,formDataPswAg}=this.state
    const {value,name}=e.target
    if(formDataName==true&&formDataEmail==true&&formDataCom==true&&formDataJob==true&&formDataPhone==true&&formDataPsw==true&&formDataPswAg==true){
      this.setState({
        getCodeBtn:true
      })
    }
    if(name=='name'){
      if(value!=''){
        this.setState({
          formDataName:true
        })
      }else{
        this.setState({
          formDataName:'nameNot'
        })
      }
    } 
    if(name=='email'){
      let reg=/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
      // console.log(reg.test(value))
      
      if(reg.test(value)){
        this.setState({
          formDataEmail:true
        })
      }else{
        this.setState({
          formDataEmail:'emailNot'
        })
      }
    }
    if(name=='company'){
      if(value!=''){
        this.setState({
          formDataCom:true,
        })
      }else{
        this.setState({
          formDataCom:'companyNot',
        })
      }
      if(this.state.mouseLeave){
        this.setState({seaCompleteItem:[]})
      }
    }
    if(name=='job'){
      if(value!=''){
        this.setState({
          formDataJob:true
        })
      }else{
        this.setState({
          formDataJob:'jobNot'
        })
      }
    }  
    if(name=='phone'){
      let reg=/^((1[3-9][0-9])+\d{8})$/
      if(reg.test(value)){
        checkPhone({phone: value})
          .then(res => {
            if(res.phone_register==true){
              this.setState({formDataPhone:'phoneAg'})
            }else{
              this.setState({
                formDataPhone:true
              })
            }
          })
      }else{
        this.setState({
          formDataPhone:'phoneNot'
        })
      }
    }
    if(name=='password'){
      if(value!=''){
        this.setState({
          formDataPsw:true
        })
      }else{
        this.setState({
          formDataPsw:'pswNot'
        })
      }
    }
    if(name=='passwordAgain'){
      // console.log(value,this.state.password)
      if(formDataName==true&&formDataEmail==true&&formDataCom==true&&formDataJob==true&&formDataPhone==true&&formDataPsw==true&&value==this.state.password){
        this.setState({
          getCodeBtn:true
        })
      }
      if(value==''){
        this.setState({
          formDataPswAg:'pswNot'
        })
      }else if(value==this.state.password){
        this.setState({
          formDataPswAg:true
        })
      }else{
        this.setState({
          formDataPswAg:'pswAgNot'
        })
      }
    }


   
    
  }

  handleSubmit(e) {
    e.preventDefault()
    const {urlBase,name,sex,email,company,job,phone,password,passwordAgain,imgCode,phoneCode,isFixed}=this.state
    // console.log(name!=''&&sex!=''&&email!=''&&company!=''&&job!=''&&phone.length==11&&password!=''&&passwordAgain==password&&imgCode!=''&&phoneCode!='')
    
    if(passwordAgain==password&&!isFixed){
      // console.log('发送注册请求',)
      // this.setState({isPass:true})

      const query = new FormData()

      query.set('name', name)
      query.set('gender', sex)
      query.set('mail', email)
      query.set('company', company)
      query.set('position', job)
      query.set('phone', phone)
      query.set('pwd', password)
      query.set('phone_code', phoneCode)
      

      register(query)
        .then(res => {
          this.setState({
            data: res,
          })

          if(res.err_code==0){
            login({
              account:phone,
              pwd:password
            })
              .then(res => {
                if(res.incomplete_results==false){

                  localStorage.setItem('user',`${res.name}`);
                  localStorage.setItem('isLogin',`true`);

                  localStorage.setItem('isCom',`${res.isCom}`)
                  localStorage.setItem('company',`${res.company}`)
                  localStorage.setItem('gender',`${res.gender}`)
                  localStorage.setItem('isExpiered',`${res.is_expiered}`)
                  
                  let u=navigator.userAgent
                  let isMobile=u.indexOf('Android')>-1||u.indexOf('Adr')>-1||!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
                  if(isMobile){
                    alert('您享有14天试用权限，并能查看五个品牌')
                  }else{
                    // alert('“恭喜您成为『数字品牌榜』注册用户，您享有14天的免费试用期，并能查看五个品牌。”')
                    this.setState({floatNews:true})
                  }
                }
              })
          } else if (res.err_msg=='phone_code is expired'){
            this.setState({
              isErr:true,
              errTxt:'验证码错误'
            })
          } else if (res.err_msg=='phone already exists'){
            this.setState({
              isErr:true,
              errTxt:'手机号已经注册'
            })
          }
        })
    }else{
      this.setState({
        isErr:true,
        errTxt:'验证码错误'
      })
      
    }
  }



  render() {
    let random = Math.random()
    const {floatNews,company,isErr,errTxt,formDataName,formDataEmail,formDataCom,formDataJob,formDataPhone,formDataPsw,formDataPswAg,getCodeBtn,modelOpen,seaCompleteItem,selectIndex,isFixed}=this.state

    return (
      <div className={s.root}>
        <FloatNews show={floatNews}  close={()=>{
            this.setState({floatNews:false})
            history.push('/')
          }}/>
        <div className={s.bg}>

          <P params={bgOption}
            style={{
              position: "absolute",
              width: "100%",
              height: "100%"
            }} 
          />

        </div>
        <div className={s.loginbox}>
          <Link to='/'><div className={s.logo}></div></Link>
          <div className={s.loginform}>
            <form action="" method="post" onSubmit={!isFixed?this.handleSubmit:null}>
              <ul className={s.registerform}>
                <li><input type="text" name='name' required value={this.state.name} placeholder="姓名" onChange={this.saveToState} onBlur={this.valid}/>
                  <i></i>
                  {formDataName==null?null:<em className={s[formDataName]}></em>}
                </li>
                <li>
                  {/* <input type="text" name='sex' value={this.state.sex} placeholder="性别" onChange={this.saveToState}/> */}
                  <select className={s.sex} onChange={(e)=>this.setState({value:e.target.value})} value={this.state.value}>
                    <option  value='0'>男</option>
                    <option value='1'>女</option>
                  </select>
                  <i></i>
                </li>
                <li><input type="email" name='email' required value={this.state.email} placeholder="邮箱" onChange={this.saveToState} onBlur={this.valid}/>
                  <i></i>
                  {formDataEmail==null?null:<em className={s[formDataEmail]}></em>}
                </li>
                <li>
                  <input 
                    required 
                    type="text" 
                    name='company' 
                    autoComplete="off"
                    value={this.state.company} placeholder="我的品牌" 
                    onChange={this.saveToState} onBlur={this.valid}  
                  />
                  <i></i>
                  {formDataCom==null?null:<em className={s[formDataCom]}></em>}
                  <div className={s.cardInput}>
                      <ul className={seaCompleteItem.length == 0 ? s.hide : s.seaItems} 
                      onMouseLeave={this.mouseLeave}
                      onMouseEnter={this.mouseEnter}
                      >
                        {seaCompleteItem
                          .map((item, index) => (
                            <li key={index} className={selectIndex % seaCompleteItem.length == index ? cx(s.seaItem, s.seaAc) : s.seaItem}
                                onMouseEnter={()=>this.mouseSlect(index)}
                                onClick={this.mouseOnClick}
                            >
                              <b><img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`} /></b>
                              {item.name}
                            </li>

                          ))}
                      </ul>
                    </div>
                </li>
                <li>
                  <input
                    type="text" name='job' 
                    required value={this.state.job} 
                    placeholder="我的职位" onChange={this.saveToState} onBlur={this.valid}/>
                  <i></i>
                  {formDataJob==null?null:<em className={s[formDataJob]}></em>}
                </li>
                <li><input type="tel" name='phone' required value={this.state.phone} placeholder="手机号" onChange={this.saveToState} onBlur={this.valid}/>
                  <i></i>
                  {formDataPhone==''?null:<em className={s[formDataPhone]}></em>}
                </li>
                <li><input type="password" name='password' required value={this.state.password} placeholder="请输入密码" onChange={this.saveToState} onBlur={this.valid}/>
                  <i></i>
                  {formDataPsw==null?null:<em className={s[formDataPsw]}></em>}
                </li>
                <li><input type="password" name='passwordAgain' required value={this.state.passwordAgain} placeholder="请确认密码" onChange={this.saveToState} onBlur={this.valid}/>
                  <i></i>
                  {formDataPswAg==null?null:<em className={s[formDataPswAg]}></em>}
                </li>
                <li><input type="text" name='imgCode' onBlur={this.checkPic} required value={this.state.imgCode} placeholder="请输入图片验证码" onChange={this.saveToState} className={s.post} />
                  <i></i>
                  <img src={this.state.url}
                    className={s.picImg}
                    onClick={() => {
                      this.setState({ url: `/digitalAssets/get_img_code?timestamp=${this.state.m}`+'&'+random})
                    }} 
                  />
                </li>
                <li>
                  <input
                    type="text"
                    value={this.state.phoneCode}
                    placeholder="请输入验证码"
                    className={s.post}
                    name='phoneCode'
                    required
                    onChange={this.saveToState}
                  />
                  <i></i>
                  <span
                    className={getCodeBtn?s.phoneCodeBtn:s.no}

                    onClick={this.getPhoneCode}
                  >{this.state.getPhoneTxt?this.state.time:'获取验证码'}</span>
                </li>
              </ul>
              <span className={s.read}><input type="checkbox" name="" id="" value="" checked={this.state.isChecked} onChange={()=>{this.setState({isChecked:!this.state.isChecked})}}/>
                <label htmlFor="">同意</label>
                <a  onClick={()=>this.setState({modelOpen:true})} href="javascript:;">《DBRank用户使用协议》</a>
              </span>
              <span    className={isErr?s.err:s.hide}>{errTxt}</span>
              <input type="submit" value="注册" />
            </form>
            <span id="swithLogin">已有账号？马上<Link to='/login'>登录</Link>
            </span>
          </div>

        </div>
        <div className={modelOpen?s.model:s.hide} onClick={()=>this.setState({modelOpen:false})}>
        </div>
        <div className={modelOpen?s.agreement:s.hide}>
            <h2>《DBRank用户使用协议》</h2>
            <div className={s.overScroll}>

            <div className={s.hideScroll}>
                <p className={s.userP}>  尊敬的用户您好，欢迎您访问DBrank数字品牌榜网站（以下简称：网站）。在您注册成为网站会员之前，请您务必认真阅读和理解《网站用户注册协议》（以下简称：协议）中所有的条款。您须完全同意协议中所有的条款，才可以注册成为本网站的会员，使用里面的服务。您在网站的注册和操作均将被视为是您对协议所有条款及内容的自愿接受。</p>
                <b>第一条 声明</b>
                <p>
                  <span>（一）网站内在线产品的所有权和运营权归北京数榜信息科技有限公司所有。</span>
                  <span>（二）您在网站进行注册时，一旦勾选“同意《DBrank用户使用协议》”复选框，即表示为您已自愿接受协议中所有的条款和内容。</span>
                  <span>（三）协议条款的效力范围仅限于本网站，您在网站的行为均受协议的约束。</span>
                  <span>（四）您使用网站服务的行为，即被视为您已知悉本网站的相关公告并同意。</span>
                  <span>（五）对于普通注册用户，本网站有权在未提前通知您的情况下修改、暂停网站部分或全部的服务，且不承担由此产生的来自您和第三方的任何责任。</span>
                  <span>（六）本网站提供免费注册服务，您的注册均是自愿行为，注册成功后，您可以得到网站更加完善的服务。</span>
                  <span>（七）您注册成为会员后账户和密码如有遗失，不会影响到您已办理成功业务的效力，本网站可恢复您的注册账户及相关信息，但不承担除此以外的其它任何责任。</span>
                </p>
                <p>
                  <b>第二条 用户管理</b>
              　　<span>（一）您在本网站的所有行为均须符合中国的法律法规，您不得利用本网站提供的服务制作、复制、发布、传播以下信息：</span>
                  <span>1、反对宪法基本原则的；</span>
                  <span>2、危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一的；</span>
                  <span>3、损害国家荣誉和利益的；</span>
                  <span>4、煽动民族仇恨、民族歧视、破坏民族团结的；</span>
                  <span>5、破坏国家宗教政策，宣扬邪教和封建迷信的；</span>
                  <span>6、散布谣言、扰乱社会秩序、破坏社会稳定的；</span>
                  <span>7、散布淫秽、色情、赌博、暴力、凶杀、恐怖内容或者教唆犯罪的；</span>
                  <span>8、侮辱或者诽谤他人，侵害他人合法权益的；</span>
                  <span>9、以及法律、法规禁止的其他内容；</span>
                  <span>（二）您在本网站的行为，还必须符合其它国家和地区的法律规定以及国际法的有关规定。</span>
                  <span>（三）不得利用本网站从事以下活动：</span>
                  <span>1、未经允许，进入他人计算机信息网络或者使用他人计算机信息网络的资源；</span>
                  <span>2、未经允许，对他人计算机信息网络的功能进行删除、修改或增加；</span>
                  <span>3、未经允许，对他人计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加；</span>
                  <span>4、制作、故意传播计算机病毒等破坏性程序的；</span>
                  <span>5、其他危害计算机信息网络安全的行为；</span>
                  <span>（四）遵守本网站其他规定和程序：</span>
                  <span>1、您对自己在本网站中的行为和操作承担全部责任；</span>
                  <span>2、您承担责任的形式包括但不仅限于，对受到侵害者进行赔偿、在本网站首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予本网站的等额赔偿；</span>
                  <span>3、如果本网站发现您传输的信息含有本协议第二条所列内容之一的，本网站有权在不通知您的情况下采取包括但不仅限于向国家有关机关报告、保存有关记录、删除该内容及链接地址、关闭服务器、暂停您账号的操作权限、停止向您提供服务等措施；</span>
                </p>
                <p>
                  <b>第三条 注册会员权利和义务</b>
                  <span>（一）注册会员有权用本网站提供的服务功能。</span>
                  <span>（二）注册会员同意遵守包括但不仅限于《中华人民共和国保守国家秘密法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《互联网电子公告服务管理规定》、《互联网信息服务管理办法》等在内的法律、法规。</span>
                  <span>（三）您注册时有义务提供完整、真实的个人信息，信息如有变更，应及时更新。</span>
                  <span>（四）您成为注册会员须妥善保管用户名和密码，用户登录后进行的一切活动均视为是您本人的行为和意愿，您负全部责任。</span>
                  <span>（五）您在使用本网站服务时，同意且接受本网站提供的各类信息服务。</span>
                  <span>（六）您使用本网站时，禁止有以下行为：</span>
                  <span>1、上载、张贴、发送电子邮件或以其他方式传送含有违反国家法律、法规的信息或资料，这些资料包括但不仅限于资讯、资料、文字、软件、音乐、照片、图形、等（下同）；</span>
                  <span>2、散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的资料；</span>
                  <span>3、冒充任何个人或机构，或以虚伪不实的方式误导他人以为其与任何人或任何机构有关；</span>
                  <span>4、通过本网站干扰、破坏或限制他人计算机软件、硬件或通讯设备功能的行为；</span>
                  <span>5、通过本网站跟踪或以其他方式骚扰他人。</span>
                </p>
                <p>
                  <b>第四条 用户隐私</b>
                  <span>我们承诺，对您个人的信息和隐私的安全承担保密义务。未经您授权或同意，本网站不会将您的个人资料信息泄露给第三方，但以下情况除外，且本网站不承担任何责任：</span>
                  <span>（一）政府单位按照中华人民共和国的法律、行政法规、部门规章、司法解释等规范性法律文件（统称“法律法规”），要求本网站提供的；</span>
                  <span>（二）由于您将用户和密码告知或泄露给他人，由此导致的个人资料泄露；</span>
                  <span>（三）包括但不仅限于黑客攻击、计算机病毒侵入或发作、政府管制等不可抗力而造成的用户个人资料泄露、丢失、被盗用或被篡改等；</span>
                  <span>（四）您通过本网站链接其他网站造成的个人资料泄露以及由此导致的任何法律争议和后果；</span>
                  <span>（五）为免除他人正在遭受威胁到其生命、身体或财产等方面的危险，所采取的措施；</span>
                  <span>（六）本网站会与其他网站链接，但不对其他网站的隐私政策及内容负责；</span>
                  <span>（七）此外，您若发现有任何非法使用您的用户账号或安全漏洞的情况，应立即通告本网站；</span>
                  <span>（八）由于您自身的疏忽、大意等过错所导致的；</span>
                  <span>（九）您在本网站的有关记录有可能成为您违反法律法规和本协议的证据。</span>
                </p>
                <p>
                  <b>第五条 知识产权</b>
                  <span>本网站所有的域名、商号、商标、开发技术、设计、文字、视像及声音内容、图形及图像均受有关所有权和知识产权法律的保护，未经本网站事先以书面明确允许，任何个人或单位，均不得进行复制和使用。</span>
                </p>
                <p>
                  <b>第六条 法律适用</b>
                  <span>（一）协议由本网站的所有人负责修订，并通过本网站公布，您的注册行为即被视为您自愿接受协议的全部条款，受其约束。</span>
                  <span>（二）协议的生效、履行、解释及争议的解决均适用中华人民共和国法律。</span>
                  <span>（三）您使用网站提供的服务如产生争议，原则上双方协商解决，协商不成可向本网站所有人所在的仲裁机构、人民法院进行调解或提起诉讼。</span>
                  <span>（四）协议的条款如与法律相抵触，本网站可进行重新解释，而其他条款则保持对您产生法律效力和约束。</span>
                </p>
            </div>
            </div>
            
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Register);



// WEBPACK FOOTER //
// src/routes/register/Register.js